import React, { useEffect, useState } from "react";
import CommonLayout from "./CommonLayout";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { useSearch } from "hooks/useFetch";
import ItemCard from "components/ItemCard/ItemCard";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ItemCardLoading from "components/ItemCard/ItemCardLoading";
import { Link } from "react-router-dom";
import Modal from "shared/Modal";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { deleteProduct } from "actions/productActions";
import { Alert } from "shared/Alert/Alert";

const VendorStatus = () => {
  const { userInfo } = useSelector((state: RootState) => state.userInfo);
  const [open, setOpen] = useState<boolean>(false);
  const [id, setId] = useState<string>("");

  const dispatch = useDispatch();

  const {
    success,
    loading: load,
    error,
  } = useSelector((state: RootState) => state.productDelete);

  const [data, loading] = useSearch(`ownerId=${userInfo.id}`);

  const handleDeleteOpen = (e: string) => {
    setId(e);
    setOpen(true);
  };

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }, [success]);

  const handleDelete = () => {
    dispatch(deleteProduct(id));
  };

  const renderModal = () => {
    return (
      <Modal
        open={open}
        handleOpen={() => setOpen(!open)}
        title="Apakah anda yakin ingin menghapus produk ini?"
      >
        <div className="w-full border-b border-neutral-200 dark:border-neutral-700 mb-10"></div>
        {success && <Alert type="success">Produk berhasil dihapus</Alert>}
        {error && <Alert type="error">Gagal</Alert>}
        <div className="flex justify-end gap-2 sm:gap-4">
          <ButtonSecondary onClick={() => setOpen(!open)}>
            Kembali
          </ButtonSecondary>

          <ButtonPrimary onClick={handleDelete} loading={load}>
            Hapus
          </ButtonPrimary>
        </div>
      </Modal>
    );
  };

  return (
    <div>
      <CommonLayout>
        {renderModal()}
        <div className="space-y-6 sm:space-y-8">
          {/* HEADING */}
          <div className="flex flex-wrap justify-between">
            <h2 className="text-3xl font-semibold mb-3 ">Listingmu</h2>
            <ButtonPrimary
              className="w-auto"
              href={"/add-listing-1"}
              targetBlank
            >
              Sewakan Barangmu
            </ButtonPrimary>
          </div>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          {/*// TODO: Buat grafik untuk jumlah view, */}
        </div>
        <div className="mt-8">
          {loading ? (
            <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                <ItemCardLoading key={item}></ItemCardLoading>
              ))}
            </div>
          ) : data && data.length > 0 ? (
            <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {data.map((item) => (
                <ItemCard
                  key={item._id}
                  data={item}
                  listing={true}
                  handleDelete={handleDeleteOpen}
                />
              ))}
            </div>
          ) : (
            <div>
              Kamu tidak punya produk apapun.{" "}
              <Link
                to="/add-listing-1"
                className="font-bold text-primary-6000"
                target={"_parent"}
              >
                Sewakan barangmu sekarang!
              </Link>
            </div>
          )}
        </div>
      </CommonLayout>
    </div>
  );
};

export default VendorStatus;
